import { getTourConfigRequest } from "@common";
import { Action } from "redux";
import { TourState } from "./state";

export function tourReducer(state: TourState, action: Action): TourState {
    return getTourConfigRequest.reducer(state, action);
}
